<sc-flex vertical fitHeight stretchContent>
  <sc-dialog-title>
    <sc-dictionary-label dictionaryKey="tmc-yard.ui.control.sac-client.moving-order-dialog.title"></sc-dictionary-label>
  </sc-dialog-title>

  <sc-flex-fitting-content vertical>
    <sc-padding fitHeight>

      <sc-flex vertical stretchContent fitHeight>

        <sc-flex-fitting-content vertical>
          <sc-scroll-pane>
            <app-moving-order-vehicle-selection
              (selectedVehicle)="vehicleSelected($event)"></app-moving-order-vehicle-selection>
          </sc-scroll-pane>
        </sc-flex-fitting-content>

        <sc-content-spacer vertical></sc-content-spacer>

        <div>
          <sc-padding>
            <mat-slide-toggle [(ngModel)]="withTransport">
              <sc-dictionary-label dictionaryKey="tmc-yard.ui.control.sac-client.moving-order-dialog.merge-with-planned-transport"></sc-dictionary-label>
            </mat-slide-toggle>
          </sc-padding>
        </div>

        <sc-flex-fitting-content vertical *ngIf="withTransport">
          <sc-scroll-pane>
            <app-planned-transport-selection [targetStationId]="targetStationId" [onlyPlanned]="true"
              [findOnlyNextPlannedRoutingPosition]="true"
              (selectedTransport)="transportSelected($event)"></app-planned-transport-selection>
          </sc-scroll-pane>
        </sc-flex-fitting-content>

      </sc-flex>

    </sc-padding>

  </sc-flex-fitting-content>

  <sc-padding>
    <sc-flex>
      <sc-content-spacer grow></sc-content-spacer>
      <sc-cancel-button mat-dialog-close dictionaryKey="tmc-yard.common.action.cancel"></sc-cancel-button>
      <sc-content-spacer></sc-content-spacer>
      <sc-button primary [disabled]="!createMovementOrderEnabled" (click)="createMovementOrder()" dictionaryKey="tmc-yard.ui.control.sac-client.moving-order-dialog.action.createMovingOrder">
      </sc-button>
    </sc-flex>
  </sc-padding>
</sc-flex>
